import { redirect } from 'react-router';
import { loadOnboarding, onboardingComplete } from '../lib/onboarding/store';
import { currentSession, identityOf } from '../lib/supabase';
import type { RootLoaderData } from '../lib/types';

/**
 * The gate for everything inside the studio. Pages below the root layout can
 * assume a session exists, and that induction is done — so nothing under here
 * has to render a half-known person.
 */
export async function rootLoader(): Promise<RootLoaderData | Response> {
  const session = await currentSession();
  if (!session) return redirect('/signed-out');

  const profile = await loadOnboarding(session);
  if (!onboardingComplete(profile)) return redirect('/onboarding');

  return { identity: identityOf(session), profile };
}
